import axios from 'axios'

export default {
    /**
     * Get current user.
     *
     * @returns {AxiosPromise<any>}
     */
    get() {
        return axios.get('/api/user')
    },

    /**
     * Get current user bookmarks.
     *
     * @returns {AxiosPromise<any>}
     */
    bookmarks(params) {
        return axios.get('/api/user/bookmarks', { params })
    },

    /**
     * Update current user data.
     *
     * @param user
     * @returns {AxiosPromise<any>}
     */
    update(user) {
        // Fake put request. Google for it.. :S
        user['_method'] = 'PUT';

        // When file is set, set up file upload request
        if (user.file) {
            console.log('Building formdata');
            let formData = new FormData();
            Object.keys(user).forEach(key => formData.append(key, user[key] ? user[key] : ''));
            user = formData;
        }

        return axios.post('/api/user', user)
    },


    /**
     * Get authenticated user's inbox stats.
     *
     * @returns {AxiosPromise<any>}
     */
    inboxStatistics() {
        return axios.get('/api/user/inbox/statistics');
    },

    /**
     * Set received comment as seen.
     *
     * @param commentId
     * @returns {AxiosPromise<any>}
     */
    seenComment(commentId) {
        return axios.post('/api/user/comments/' + commentId + '/seen', { '_method': 'PUT' })
    },

    /**
     *
     * @returns {AxiosPromise<any>}
     */
    comments(params) {
        return axios.get('/api/user/comments', { params })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/user.js